module.exports = __webpack_public_path__ + "img/card42.34341964.png";